import React, { lazy, Suspense } from "react";
import { useI18n } from "@/contexts/I18nContext";

function DynamicLoadingFallback() {
  const { t } = useI18n();
  return <div>{t("common.loading")}</div>;
}

const componentMap = {
  "/system/users": () => import("@/features/admin/system/users"),
  "/system/roles": () => import("@/features/admin/system/roles"),
  "/system/menus": () => import("@/features/admin/system/menus"),
  "/system/common-codes": () => import("@/features/admin/system/common-code"),
  "/edi/customers": () => import("@/features/admin/edi/customers"),
  "/edi/connections": () => import("@/features/admin/edi/connections"),
  "/edi/tls-certificates": () =>
    import("@/features/admin/edi/tls-certificates"),
  "/edi/documents": () => import("@/features/admin/edi/documents"),
  "/edi/document-routes": () => import("@/features/admin/edi/document-routes"),
  "/edi/schedulers": () => import("@/features/admin/edi/schedulers"),
  "/edi/raw-documents": () => import("@/features/admin/edi/raw-documents"),
  "/edi/unknown-raw-documents": () =>
    import("@/features/admin/edi/unknown-raw-documents"),
  "/edi/cello-sends": () => import("@/features/admin/edi/cello-sends"),
  "/edi/cello-ackans-sends": () =>
    import("@/features/admin/edi/cello-ackans-sends"),
  "/edi/cello-genres": () => import("@/features/admin/edi/cello-genres"),
  "/edi/cello-datas": () => import("@/features/admin/edi/cello-datas"),
  "/edi/devtools": () => import("@/features/admin/edi/devtools"),
  "/dashboard": () => import("@/features/admin/dashboard"),
};

export function getDynamicComponent(key) {
  const loader = componentMap[key];
  if (!loader) return null;

  // lazy로 import
  const LazyComponent = lazy(loader);

  // Suspense로 감싸서 로딩 처리
  const DynamicComponent = (props) => (
    <Suspense fallback={<DynamicLoadingFallback />}>
      <LazyComponent {...props} />
    </Suspense>
  );

  // preload 기능 흉내내기 (미리 import)
  DynamicComponent.preload = () => {
    loader();
  };

  return DynamicComponent;
}
